import { ADMIN_FUNCTIONS, SC_MODULES } from '@app/constants/sc.modules';
import myIcon from '@app/assets/images/icons/ic/calculator.svg';
import paymentVoucherIcon from '@app/assets/images/icons/ic/finance.svg';
import PaymentVoucherPage from '@modules/school-service/pages/Income/PaymentVoucherPage';
import Receipt from '@modules/school-service/pages/Income/ReceiptPage';
import { IRouteConfig } from '../route.types';

const receiptsRoutes: IRouteConfig[] = [
    {
        name: 'LẬP PHIẾU THU',
        icon: myIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        link: '/receipt',
        path: '/receipt',
        main: () => <Receipt />,
        functionId: ADMIN_FUNCTIONS.RECEIPTS,
    },
    {
        name: 'LẬP PHIẾU CHI',
        icon: paymentVoucherIcon,
        isMenu: true,
        isRoute: true,
        exact: false,
        moduleId: SC_MODULES.SERVICE,
        link: '/payment-voucher',
        path: '/payment-voucher',
        main: () => <PaymentVoucherPage />,
        functionId: ADMIN_FUNCTIONS.RECEIPTS,
    },
];

export default receiptsRoutes;
